import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const getReferenceTypesList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/reference-type"
  });
  return response;
};

export const getSkillCategoriyList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/world-skill-category"
  });
  return response;
};

export const deleteReferenceType = id => {
  return instance({
    method: "delete",
    url: `/work/api/dict/reference-type/${id}`
  });
};

export const deleteSkillCategory = id => {
  return instance({
    method: "delete",
    url: `/work/api/dict/reference-type/${id}`
  });
};

export const getDictItem = (id, dicttype) => {
  if (dicttype === 1) return getReferenceType(id);
  if (dicttype === 9) return getSkillCategory(id);
  else return null;
};

export const createDictItem = (data, dicttype) => {
  if (dicttype === 1) return createReferenceType(data);
  if (dicttype === 9) return createSkillCategory(data);
  else return null;
}

export const updateDictItem = (id, data, dicttype) => {
  if (dicttype === 1) return updateReferenceType(id, data);
  if (dicttype === 9) return updateSkillCategory(id, data);
  else return null;
}

export const getReferenceType = (id) => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/reference-type/${id}`
  });
  return response;
};

export const getSkillCategory = (id) => {
  const response = instance({
    method: "get",
    url: `/work/api/dict/world-skill-category/${id}`
  });
  return response;
};


export const createReferenceType = (data) => {
  const response = instance({
    method: "post",
    url: '/work/api/dict/reference-type',
    data
  });
  return response;
}

export const updateReferenceType = (id, main) => {
  const data = {
    main: {
      ...main,
    }
  }

  const response = instance({
    method: "put",
    url: `/work/api/dict/reference-type/${id}`,
    data
  });
  return response;
};

export const createSkillCategory = (data) => {
  const response = instance({
    method: "post",
    url: '/work/api/dict/world-skill-category',
    data
  });
  return response;
}

export const updateSkillCategory = (id, main) => {
  const data = {
    main: {
      ...main,
    }
  }

  const response = instance({
    method: "put",
    url: `/work/api/dict/world-skill-category/${id}`,
    data
  });
  return response;
};

export default {
  getReferenceTypesList,
  deleteReferenceType,
  getSkillCategoriyList,
  deleteSkillCategory,
  getDictItem,
  createDictItem,
  updateDictItem
}
